import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import ShareIcon from '@mui/icons-material/Share'
import { Container, Menu, MenuItem } from '@mui/material'
import React, { forwardRef, useCallback, useState } from 'react'

import CButton from './CButton'
import { copyToClipboard, fallbackCopyTextToClipboard } from '../../utils/utility'

const ShareButton = forwardRef(({ title, text, url, size = 'medium', sx, ...props }, ref) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleShare = useCallback((event) => {
    event.stopPropagation() // 防止触发卡片的点击事件
    setAnchorEl(event.currentTarget)
  }, [])

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleNativeShare = () => {
    handleClose()
    // 检测是否为iOS设备
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

    // 如果支持原生分享API (iOS Safari和某些Android浏览器支持)
    if (navigator.share) {
      navigator
        .share({
          title: title,
          text: text,
          url: url,
        })
        .then(() => {
          console.log('Successfully shared')
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            return
          } else {
            if (!isIOS) {
              copyToClipboard(url)
            } else {
              fallbackCopyTextToClipboard(url)
            }
          }
        })
    } else {
      copyToClipboard(url)
    }
  }

  const handleCopy = () => {
    copyToClipboard(url)
    handleClose()
  }

  return (
    <Container
      sx={{
        m: 0,
        minWidth: 'unset',
        width: '32px',
        height: '32px',
        padding: '0px',
      }}
    >
      <CButton title={title} onClick={handleShare} size={size}>
        <ShareIcon fontSize={size} />
      </CButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} onClick={(e) => e.stopPropagation()}>
        {navigator.share && (
          <MenuItem onClick={handleNativeShare}>
            <ShareIcon sx={{ mr: 1 }} fontSize="small" />
            Share
          </MenuItem>
        )}
        <MenuItem onClick={handleCopy}>
          <ContentCopyIcon sx={{ mr: 1 }} fontSize="small" />
          Copy Link
        </MenuItem>
      </Menu>
    </Container>
  )
})

export default ShareButton
